// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"351":"5468dc645c92da15","410":"024da8d752d9279f","418":"2854e4785af2a980","593":"e2a0ed594325ed14","674":"3643394796b17286","846":"c04782e7f31e9568"}[chunkId] + ".js";
};